import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { TokenService } from './token.service';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthService {
  svrUrl = '';
  apiUrl = this.svrUrl + '/api';
  base = this.apiUrl + '/auth';

  constructor(private http: HttpClient, private token: TokenService, private router: Router) {}

  requestApi(reqFor: string, reqType: string, id: number, frmData: any): Observable<any> {
    if (reqType === 'all_data') {
      return this.http.get<any[]>(`${this.apiUrl}/${reqFor}`);
    } else if (reqType === 'all_dataZ') {
      return this.http.post<any>(`${this.apiUrl}/${reqFor}`, frmData);
    } else if (reqType === 'create') {
      return this.http.post<any>(`${this.apiUrl}/${reqFor}`, frmData);
    } else if (reqType === 'update') {
      return this.http.put<any>(`${this.apiUrl}/${reqFor}/${id}`, frmData);
    } else if (reqType === 'delete') {
      return this.http.delete<any>(`${this.apiUrl}/${reqFor}/${id}`);
    } else if (reqType === 'get_data') {
      return this.http.get<any>(`${this.apiUrl}/${reqFor}/${id}`);
    } else if (reqType === 'upload') {
      return this.http.post<any>(`${this.apiUrl}/${reqFor}`, frmData, {
        reportProgress: true,
        observe: 'events'
      });
    }

    // Fallback ensures the method always returns an observable stream
    console.warn(`Unhandled request type: ${reqType}`);
    return of(null); 
  }

  // Call this API for payment transaction
  initiatePayment(paymentData: { amount: number; transactionId: string; userId: string }): Observable<{ url: string }> {
    return this.http.post<{ url: string }>(`${this.apiUrl}/pay`, paymentData);
  }

  // Call this API to check the payment status
  checkStatus(transactionId: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/payment-status/${transactionId}`);
  }

  sendEmail(data: any): Observable<any> {
    return this.http.post(this.apiUrl + '/email', data);
  }

  login(payload: {erp_key: string, user_name:string, password:string}) {
    if(payload.erp_key && payload.user_name && payload.password) {
      return this.http.post<any>(`${this.base}/erp-login`, payload).pipe(
        tap(res => { if (res?.token) this.token.setToken(res.token); })
      );
    } else {
      return this.http.post<any>(`${this.base}/login`, payload).pipe(
        tap(res => { if (res?.token) this.token.setToken(res.token); })
      );
    }
  }

  logout() {
    this.token.clear();

    localStorage.removeItem("crud_jwt");
    localStorage.removeItem("data4chk");
    localStorage.removeItem("erp_chat_conversations");

    sessionStorage.removeItem("my_modules");
    this.router.navigate(['/login']);
  }

  isAuthenticated(): boolean {
    return !!this.token.getToken();
  }

  // decodeJWT(token: any) {
  //   const base64Url = token.split('.')[1]; // Extract the payload section
  //   const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/'); // Convert Base64Url to Base64
  //   const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
  //       return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  //   }).join(''));
  //   return JSON.parse(jsonPayload);
  // }

}
